import { DateTime } from 'luxon';

import { Calendar } from '@shared/assets';

import * as st from './index.module.scss';

const StartDate = ({ date }) => {
	return (
		<div className={st.date}>
			<div className={st.date__icon}>
				<Calendar />
			</div>
			<span className={st.date__text}>{DateTime.fromISO(date).toFormat('DDD')}</span>
		</div>
	);
};

export default StartDate;
